import React from "react";

export default function AboutSection() {
  return (
    <section
      id="about"
      className="relative"
      style={{ background: "var(--kw-yellow)" }}
      data-testid="about-section"
    >
      <div className="container-kw section">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
          <div className="md:col-span-4">
            <div className="eyebrow text-[color:var(--kw-black)]/70">
              About the Company
            </div>
            <h2 className="mt-5 font-display font-bold text-4xl md:text-5xl tracking-tight text-[color:var(--kw-black)]">
              Products with purpose.
            </h2>
          </div>
          <div className="md:col-span-8">
            <p className="text-xl md:text-2xl leading-relaxed text-[color:var(--kw-black)] font-medium">
              King&apos;s Wake Digital Pvt. Ltd. is a product-focused company
              dedicated to building and operating scalable digital platforms.
            </p>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-[color:var(--kw-black)]/80">
              We believe technology should serve people with clarity, fairness,
              and purpose—creating systems that are not only engaging, but
              genuinely valuable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
